<template>
    <div class="bg-white px-2 py-2 border-b border-gray-200 sm:px-6">
        <div class="-mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap">

            <span class="h-4 mt-2 relative z-0 inline-flex">
                <button v-if="!$page.props?.selectedUser?.settings.automatic_delivery && (this.activePage === 'inbox' || this.activePage === 'sent')" @click.prevent="refreshMessages(1)" type="button" class="shadow-sm rounded-md mr-2 -ml-px relative inline-flex items-center px-2 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="-2.5 -2.5 25 25" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                    </svg>
                </button>

                <span v-if="this.activePage === 'inbox' || this.activePage === 'sent'" style="margin-top: 0.1rem;" class="text-xs text-gray-500">
                    Poslední aktualizace: {{ lastUpdateText }}
                </span>
            </span>

            <span class="h-4 mt-2 relative z-0 inline-flex shadow-sm rounded-md">
                <button @click.prevent="previousPage" type="button" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                    <span class="sr-only">Předchozí</span>
                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <button type="button" class="-ml-px relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                    {{ parseInt(page) + 1 }}
                    z
                    {{ parseInt(maxPage) + 1 }}
                </button>
                <button @click.prevent="nextPage" type="button" class="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                    <span class="sr-only">Další</span>
                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </span>

        </div>
    </div>
</template>

<script>
export default {
    name: "MessagesTableActionHeader",
    props: [],
    emits: ['refreshMessages'],
    data(){
        return {
            lastUpdate: this.$page.props.lastUpdate,
            page: this.$page.props.page,
            maxPage: this.$page.props.maxPage,

            activePage: this.$page.props.activePage,

        }
    },
    methods: {
        previousPage(){
            if(this.activePage === 'inbox') if(this.page > 0) this.$inertia.visit(route('app', {page: parseInt(this.page) - 1}));
            if(this.activePage === 'longterminbox') if(this.page > 0) this.$inertia.visit(route('longterminbox', {page: parseInt(this.page) - 1}));
            if(this.activePage === 'sent') if(this.page > 0) this.$inertia.visit(route('sent', {page: parseInt(this.page) - 1}));
            if(this.activePage === 'longtermsent') if(this.page > 0) this.$inertia.visit(route('longtermsent', {page: parseInt(this.page) - 1}));
            if(this.activePage === 'trash') if(this.page > 0) this.$inertia.visit(route('trash', {page: parseInt(this.page) - 1}));
        },
        nextPage(){
            if(this.activePage === 'inbox') if(this.page < this.maxPage) this.$inertia.visit(route('app', {page: parseInt(this.page) + 1}));
            if(this.activePage === 'longterminbox') if(this.page < this.maxPage) this.$inertia.visit(route('longterminbox', {page: parseInt(this.page) + 1}));
            if(this.activePage === 'sent') if(this.page < this.maxPage) this.$inertia.visit(route('sent', {page: parseInt(this.page) + 1}));
            if(this.activePage === 'longtermsent') if(this.page < this.maxPage) this.$inertia.visit(route('longtermsent', {page: parseInt(this.page) + 1}));
            if(this.activePage === 'trash') if(this.page < this.maxPage) this.$inertia.visit(route('trash', {page: parseInt(this.page) + 1}));
        },
        refreshMessages(manual = 0){
            this.$emit('refreshMessages', manual);
        }

    },

    computed: {
        lastUpdateText: function() {
            let datetime = new Date(this.lastUpdate);
            return datetime.toLocaleDateString() + ', ' + datetime.toLocaleTimeString();
        },
    }
}
</script>

<style scoped>

</style>
